export default {
  number: "",
  name: "",
  category: "",
  // condition: "",
  distance: 0
}
